import { Component, inject } from '@angular/core';
import { HeaderComponent } from '../../core/shared/layout/header/header.component';
import { SideNavComponent } from '../../core/shared/layout/side-nav/side-nav.component';
import { FooterComponent } from '../../core/shared/layout/footer/footer.component';
import { BottomNavigationComponent } from '../../core/shared/layout/bottom-navigation/bottom-navigation.component';
import { UserService } from '../../core/services/user/user.service';
import { UserVipService } from '../../core/services/user/user-vip.service';
import { TranslatePipe } from '../../core/shared/translation/translate.pipe';
import { BoxComponent } from '../../core/shared/components/box/box.component';
import { SliderComponent } from '../../core/shared/components/slider/slider.component';
import { AsyncPipe, NgStyle, NgTemplateOutlet, SlicePipe } from '@angular/common';
import { VipLevelLabelComponent } from './vip-level-label/vip-level-label.component';
import { VipProgressBarComponent } from './vip-progress-bar/vip-progress-bar.component';
import { isMobile } from '../../core/helpers/device';
import { CopyService } from '../../core/services/copy.service';
import { AccordionDirective } from 'ngx-unificator/directives';
import { GamePreviewComponent } from '../../core/shared/layout/game-preview/game-preview.component';
import { TournamentPreviewComponent } from '../../core/shared/layout/tournament-preview/tournament-preview.component';
import { TermsComponent } from '../../core/shared/components/terms/terms.component';
import { BonusPreviewComponent } from '../../core/shared/components/bonus-preview/bonus-preview.component';
import { RouterLink } from '@angular/router';
import { BonusStageEnum } from '../../core/services/user/data/user-bonuses.data';
import { BtnComponent } from '../../core/shared/components/btn/btn.component';

@Component({
  selector: 'app-vip-page',
  imports: [
    HeaderComponent,
    SideNavComponent,
    FooterComponent,
    BottomNavigationComponent,
    TranslatePipe,
    BoxComponent,
    SliderComponent,
    NgTemplateOutlet,
    NgStyle,
    VipLevelLabelComponent,
    VipProgressBarComponent,
    SlicePipe,
    AccordionDirective,
    AsyncPipe,
    GamePreviewComponent,
    TournamentPreviewComponent,
    TermsComponent,
    BonusPreviewComponent,
    RouterLink,
    BtnComponent,
  ],
  templateUrl: './vip-page.component.html',
  styleUrl: './vip-page.component.scss',
})
export class VipPageComponent {

  public user: UserService = inject(UserService);
  public vip: UserVipService = inject(UserVipService);
  public copy: CopyService = inject(CopyService);

  protected readonly isMobile = isMobile;

  showMore(count: number) {
    this.vip.vipStore.storeSignal.update(store => {
      return {
        ...store,
        visibleRulesCount: count,
      };
    });
  }

  protected readonly BonusStage = BonusStageEnum;
}
